import { config } from "../../../utils/config";
import { fetchDataAndMapToField } from "../../../utils/helperFuctions";

const useVehicleModelsLogic = () => {
  const apiRoute = "vehiclemodels";
  const onlyForm = undefined;

  const initFields = [
    {
      name: "name",
      label: "Vehicle Model Name",
      type: "text",
      isRequired: true,
      err: "Vehicle Model Name is required",
    },
    {
      name: "brand",
      label: "Brand",
      type: "dropdown",
      isRequired: true,
      err: "Brand is required",
      returnID: true,
    },
    // Add more fields as needed
  ];

  //Roles
  const admin = process.env.REACT_APP_ADMIN_ROLE;
  const managerRole = process.env.REACT_APP_MANAGER_ROLE;
  const financeRole = process.env.REACT_APP_FINANCE_ROLE;
  ///Add,Delete,Edit Roles
  const addRoles = [admin, managerRole, financeRole];
  const deleteRoles = [admin, managerRole, financeRole];
  const editRoles = [admin, managerRole, financeRole];

  const getPromises = (temp) => {
    return [
      fetchDataAndMapToField(config, "vehiclebrands", "brand", temp, "name"),
    ];
  };

  return {
    apiRoute,
    addRoles,
    editRoles,
    deleteRoles,
    initFields,
    getPromises,
    onlyForm,
  };
};

export default useVehicleModelsLogic;
